
var apiBaseURL = process.env.REACT_APP_API_PATH;

export const updateAPIData = async (_url, data) => {
  var response;
  var obj = data;
  const url = apiBaseURL + _url;

  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(obj),
    });


  } catch (error) {
    console.log("error", error);

  } finally {

    if (response.status > 400) {
      return { "message": response.statusText }
    }
    else {
      return { "message": "success" }
    }
  }

}


export const postData = async (
  url = '',
  data = {},
  isFormData = false
) => {

  try {

    const options = {
      method: 'POST',
    };

    // =========================
    // FORM DATA
    // =========================

    if (isFormData) {

      options.body = data;

    } else {

      options.headers = {
        'Content-Type': 'application/json',
      };

      options.body =
        JSON.stringify(data);
    }

    // =========================
    // DEBUG
    // =========================

    if (data instanceof FormData) {

      for (let pair of data.entries()) {

        console.log(
          pair[0],
          pair[1]
        );
      }
    }

    // =========================
    // API CALL
    // =========================
 
    const response = await fetch(
      apiBaseURL + url,
      options
    );

    const res = await response.json();

    return res;

  } catch (error) {

    console.error('Error:', error);

    return {
      success: false,
      error: error.message,
    };
  }
};


export const getData = async (url = '', data = '') => {

   
  var response = null;
  // Default options are marked with *
  response = await fetch(apiBaseURL+url + '?' + data, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  return response.json()

}


export const putData = async (url = '', data = {}) => {

  console.log("CALL POST DATA---",data)

  try {
    const response = await fetch(apiBaseURL+url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    const res = await response.json();
    return res;
     
} catch (error) {
    console.error('Error:', error);
}

 

}
export const deleteData = async (url = '', data = '') => {

    const location = window.location.pathname;
 

  var response = null;
  // Default options are marked with *+ '?' + data
  response = await fetch(apiBaseURL+url , {
    method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  return response.json()

}